import React, { useCallback, useMemo, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import BottomToTop from "../../../../components/transitions/bottom-to-top";
import { BlackMask } from "../../../../components/mask";
import { Iconfont } from "../../../../components/icon/iconfont";
import ReactDOM from 'react-dom';
import { BigButton } from "../../../../components/button";
import { FormattedMessage } from "react-intl";


const AreaCodeSub = props =>{
	const { codeItem, currentCode, setCurrentCode } = props;

	return <a onClick={()=>setCurrentCode(codeItem)} className={`${cls.AreaCodeSub} ${currentCode === codeItem ? cls.Active: ""}`}>
		<span className={cls.AreaCodeItem}>+{codeItem}</span>
		<span className={cls.Circle}></span>
	</a>
}

const SelectLocationEditor = props =>{
	const { areaCode, onClose, onSelect, areaCodes } = props;
	const [currentCode, setCurrentCode] = useState(areaCode);

	const confirmHandle = useCallback((code) =>{
		onSelect(code);
	}, []);

	return <div className={cls.SelectLocationEditor}>
		<div className={cls.SelectLocationHd}>
			<span className={cls.Font}><FormattedMessage id="country_code" defaultMessage="Country code" /></span>

			<Iconfont className={cls.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
		</div>

		<p className={cls.Message}><FormattedMessage id="select_country_code" defaultMessage="Please select the correct country code" /></p>

		<div className={cls.SelectLocationBd}>
			<div className={cls.SelectLocationList}>
				{
					areaCodes.map((code, index)=>(
						<AreaCodeSub key={code+index} setCurrentCode={setCurrentCode} codeItem={code} currentCode={currentCode} />
					))
				}
			</div>
		</div>

		<div className={cls.ConfirmSubmit}>
			<BigButton className={cls.SubBtn} onClick={()=>confirmHandle(currentCode)}><FormattedMessage id="confirm" defaultMessage="confirm" /></BigButton>
		</div>
	</div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show, onClose } = props; 

	return <React.Fragment>
		<BottomToTop in={show} className={cls.SelectLocationContainer}>
			<div>
				<SelectLocationEditor {...props} />
			</div>
		</BottomToTop>
		{show && <BlackMask onClick={onClose} style={{ zIndex: 13 }} />}
	</React.Fragment>
}

const SelectPhoneAreaWrapped = props =>{

	if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}

export default props =>{
    useStyles(cls);
	const { setCode, areaCodes, country, areaCode } = props;
    const [showModal, setShowModal] = useState(false);

	// const disposeCodeData = useMemo(() =>{
	// 	return areaCodes.map((item)=>({ areaCode: item, country: country }))
	// }, [areaCodes, country]);

	// const disposeAreaCode = useMemo(() =>{
	// 	if(areaCode.indexOf('+' != -1)){
	// 		return areaCode.replace('+', "");
	// 	}

	// 	return `+${areaCode}`;
	// }, [areaCode]);

    return <React.Fragment>
        <div onClick={()=>setShowModal(true)} className={cls.SelectFont}>
            <span className={cls.Font}>{country}&nbsp;+&nbsp;{areaCode}&nbsp;</span>
			<span className={cls.Icon}></span>
        </div>

        <SelectPhoneAreaWrapped 
            show={showModal} 
            onClose={()=>setShowModal(false)} 
            areaCode={areaCode} 
			areaCodes={areaCodes} 
            onSelect={(areaCode) =>{
                setCode(areaCode);
                setShowModal(false)
            }} 
        />
    </React.Fragment>
}